import { useSelector } from 'react-redux';
import { Button } from '@mui/material';
import { useState } from 'react';

import { Strings } from '@app/constants';
import { ProfileCard } from '@app/components/card';
import { IEmployee } from '../types';
import { selectRoleState } from '@app/modules/role';
import { useDialog } from '@app/hooks';
import { ViewDocument } from './view-document';

interface Props {
  userData: IEmployee;
}

export const ProfileDetails = ({ userData }: Props) => {
  const [selectedDocument, setSelectedDocument] = useState('');
  const presentAddress = userData?.presentAddress
    ? `${userData?.presentAddress?.address} ${userData?.presentAddress?.addressLine2} ${userData?.presentAddress?.city} ${userData?.presentAddress?.state} ${userData?.presentAddress?.postalCode}`
    : 'NA';
  const permanentAddress = userData?.permanentAddress
    ? `${userData?.permanentAddress?.address} ${userData?.permanentAddress?.addressLine2} ${userData?.permanentAddress?.city} ${userData?.permanentAddress?.state} ${userData?.permanentAddress?.postalCode}`
    : 'NA';
  const viewDocument = useDialog();
  const handleClick = (document: string) => {
    setSelectedDocument(document);
    viewDocument.show();
  };
  const roleState = useSelector(selectRoleState);
  const roles = roleState.data?.records;
  const fields = [
    Strings.field.firstName,
    Strings.field.lastName,
    Strings.field.phone,
    Strings.field.email,
    Strings.role.role,
    Strings.field.source,
    Strings.field.status,
    Strings.document.aadharCard,
    Strings.document.panCard,
    Strings.field.presentAddress,
    Strings.field.permanentAddress,
  ];
  const data = [
    userData?.firstName ?? 'NA',
    userData?.lastName ?? 'NA',
    userData?.phone || 'NA',
    userData?.email ?? 'NA',
    roles?.find((option) => option.id === userData?.roleId)?.name ?? 'NA',
    userData?.source === 'Other'
      ? userData?.other ?? 'NA'
      : userData?.source === 'Reference'
      ? `Reference By ${userData?.referenceBy ?? 'NA'}`
      : userData?.source || 'NA',

    userData?.status ?? 'NA',
    <Button
      key="aadhar"
      color="primary"
      onClick={() => {
        handleClick('aadhar');
      }}
      sx={{ bottom: '7px' }}
    >
      {Strings.button.clickHere}
    </Button>,
    <Button
      key="pan"
      color="primary"
      onClick={() => {
        handleClick('pan');
      }}
      sx={{ bottom: '7px' }}
    >
      {Strings.button.clickHere}
    </Button>,
    presentAddress,
    // eslint-disable-next-line @typescript-eslint/no-base-to-string
    permanentAddress,
  ];
  return (
    <>
      <ProfileCard
        title={Strings.profile.personalInformation}
        fields={fields}
        data={data}
        Src={
          userData?.profileImage
            ? userData?.profileImage
            : `${userData?.firstName} ${userData?.lastName}`
        }
      />
      {viewDocument.visible && (
        <ViewDocument
          open
          onClose={() => {
            viewDocument.hide();
            setSelectedDocument('');
          }}
          document={selectedDocument}
          aadharFront={userData?.aadharFront}
          aadharBack={userData?.aadharBack}
          panFront={userData?.panFront}
          panBack={userData?.panBack}
        />
      )}
    </>
  );
};
